<template>
    <div class="stars__rating">
        <div class="stars_outer">
            <div class="stars_inner" :style="{width: percentage}"></div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        rate : {
            required : true,
            type: Number
        }
    },
    computed: {
        percentage() {
            return (this.rate * 100 / 5) + '%';
        }
    },
}
</script>
